export default __webpack_public_path__ + "static/media/inlife-benefits.d350e384.png";